import { render, staticRenderFns } from "./OptionalSelection.vue?vue&type=template&id=f134712e&"
import script from "./OptionalSelection.vue?vue&type=script&lang=js&"
export * from "./OptionalSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports